import { t as translateDate } from './translate-date.js';
import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
 * **Palace Resorts Public**
 *
 * @exports bs_406
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_406
       * @see {@link on_state_change}
       *
       * @param {object} ctx - The context object.
       */
    engine.onStateChange = function onStateChange(ctx) {
        setTimeout(thn.pageCheck, 400);
    };
    /**
       * @memberOf module:bs_406
       * @see {@link prestart}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot() {
        const containerLanguage = document.querySelector('.title-language ');
        if (containerLanguage) {
            const refreshLanguage = thn.debounce(thn.languageCheck, 400);
            thn.observeDom(containerLanguage, refreshLanguage, {
                childList: true,
                characterData: true,
            });
            thn.shutdown(() => {
                refreshLanguage.cancel();
                thn.stopObserveDom(containerLanguage, refreshLanguage);
            });
        }
        const loader = document.querySelector('#loader');
        if (loader) {
            const refreshPage = thn.debounce(thn.pageCheck, 300);
            thn.observeDom(loader, refreshPage, {
                attributes: true,
            });
            thn.shutdown(() => {
                refreshPage.cancel();
                thn.stopObserveDom(loader, refreshPage);
            });
        }
    };
    /**
       * @memberOf module:bs_406
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            const lang = document.querySelector('.title-language ')?.textContent?.toLowerCase() || window.location.pathname.split('/')[1];
            if (lang && ctx.langs.test(lang)) {
                resolve(lang);
                return;
            }
            reject('no_language');
        });
    };
    /**
       * @memberOf module:bs_406
       * @see {@link is_user_logged}
       *
       * @param {object} ctx - The context object.
       */
    engine.isUserLogged = function isUserLogged(ctx) {
        const isLogged = false;
        return isLogged;
    };
    /**
     * @memberOf module:bs_406
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const containerRooms = document.querySelector('section[page="rooms"] .main-wrapper');
        if (containerRooms) {
            let refreshPrice = thn.debounce(() => {
                const isLoaderGeneral = thn.isVisible(document.querySelector('#loader'));
                const isLoaderRooms = thn.isVisible(document.querySelector('section[page="rooms"] .loader-small'));
                if (!isLoaderGeneral && !isLoaderRooms) {
                    thn.pageCheck();
                    if (document.querySelector('.content-info-rooms-summary.bg-room-active')) {
                        setTimeout(ctx.widget.refresh, 500);
                    }
                }
            }, 1000);
            thn.observeDom(containerRooms, refreshPrice, {
                childList: true,
            });
            thn.pageUnload(() => {
                refreshPrice.cancel();
                thn.stopObserveDom(containerRooms, refreshPrice);
                refreshPrice = null;
            });
        }
    };
    /**
          *
          * @memberOf module:bs_399
          *
          */
    engine._roomDetailsParseData = function roomDetailsParseData(adults, children) {
        const roomElArray = [...document.querySelectorAll('.card-rooms')].filter((room) => !room.querySelector('.content-not-available'));
        if (thn.empty(roomElArray)) {
            return {};
        }
        const roomsInfo = roomElArray.map((room) => {
            const roomName = room.querySelector('.card-header .card-title')?.textContent;
            const roomType = getRoomType(roomName);
            const ratesInfo = [...room.querySelectorAll('.content__rooms-info>div')].map((rate) => {
                const rateName = rate.querySelector('.plan-name-rooms')?.textContent;
                const ratePrice = thn.parseNumber(rate.querySelector('.offer-price')?.textContent);
                const isRefundable = !rateName?.includes('PAY IN FULL & SAVE');
                return {
                    id: '',
                    name: rateName,
                    total_night: ratePrice,
                    breakfast: false,
                    refundable: isRefundable,
                };
            });
            return {
                id: '',
                name: roomName,
                adults: adults || 2,
                children: children || 0,
                type: roomType,
                prices: ratesInfo,
            };
        });
        return roomsInfo;
    };
    /**
       * @memberOf module:bs_406
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        // Dates
        const dateBeginInput = document.querySelector('.input-group input')?.value;
        const dateEndInput = document.querySelector('.input-group-end input')?.value;
        const dateBeginRaw = thn.parseUrlParameter('skd-checkin')?.replace(/-/g, '/');
        const dateEndRaw = thn.parseUrlParameter('skd-checkout')?.replace(/-/g, '/');
        if ((dateBeginRaw && dateEndRaw) || (dateBeginInput && dateEndInput)) {
            widgetData.date_begin = dateBeginRaw || translateDate(dateBeginInput, thn.data.language || 'en');
            widgetData.date_end = dateEndRaw || translateDate(dateEndInput, thn.data.language || 'en');
        }
        // Guests, Adults & Children
        const roomNum = thn.parseNumber(document.querySelector('.content-info-rooms-summary:not(.null) .text-title-room span:nth-child(2)')?.textContent) ?? 1;
        const roomsDispo = [];
        const adults = thn.parseNumber(thn.parseUrlParameter(`adult_room${roomNum}`)) ?? 2;
        // Count children from url parameters and create an array with their ages
        let children = 0;
        const childrenAges = [];
        const maxChildrenAge = 17;
        for (let i = 0; i <= maxChildrenAge; i += 1) {
            const child = thn.parseNumber(thn.parseUrlParameter(`child_room${roomNum}_age${i}`));
            if (child) {
                children += 1;
                if (i === 0) {
                    childrenAges.push(1);
                }
                else {
                    childrenAges.push(i);
                }
            }
        }
        const roomData = {
            adults,
            children,
            children_ages: childrenAges,
        };
        roomsDispo.push(roomData);
        widgetData.rooms_dispo = roomsDispo;
        // Prices & Currency || No Rooms
        const availableRooms = [...document.querySelectorAll('.content__rooms-info')].filter((room) => !room.querySelector('.content-flexible-room'));
        const prices = availableRooms.map((roomInfo) => thn.parseNumber(roomInfo.querySelector('.offer-price .value')?.textContent)).filter(Boolean);
        const currency = document.querySelector('.title-currency>span')?.textContent;
        const isLoaderVisible = thn.isVisible(document.querySelector('#loader')) || thn.isVisible(document.querySelector('#loaderSmall'));
        if (prices.length && currency && !isLoaderVisible) {
            widgetData.price = Math.min(...prices);
            widgetData.currency = currency;
            widgetData.room_details = engine._roomDetailsParseData(adults, children);
            widgetData.set = true;
        }
        else if (!prices.length && !isLoaderVisible) {
            widgetData.no_rooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_406
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const bookingId = thn.dataLayerHelper.get('ecommerce.purchase.actionField.id') || document.querySelector('.confirmation-code p')?.textContent;
        if (!bookingId) {
            widgetData.set = false;
            return widgetData;
        }
        const datesArrayEl = document.querySelector('.containter-info-booking .cols-payment-info')?.textContent?.split('|');
        widgetData.booking_id = bookingId;
        widgetData.date_begin = thn.dataLayerHelper.get('startDate').replace(/-/g, '/') || translateDate(datesArrayEl[0], thn.data.language || 'en');
        widgetData.date_end = thn.dataLayerHelper.get('endDate').replace(/-/g, '/') || translateDate(datesArrayEl[0], thn.data.language || 'en');
        widgetData.rooms = thn.dataLayerHelper.get('numberRooms');
        widgetData.adults = thn.dataLayerHelper.get('numberOfAdults');
        widgetData.children = thn.dataLayerHelper.get('numberOfInfants') + thn.dataLayerHelper.get('numberOfKids') + thn.dataLayerHelper.get('numberOfTeens');
        widgetData.price = thn.dataLayerHelper.get('totalRooms') || thn.parseNumber(document.querySelector('.content-card-subtotal .subtotal')?.textContent);
        widgetData.currency = thn.dataLayerHelper.get('currencyCode') || document.querySelector('.title-currency>span')?.textContent;
        return widgetData;
    };
    /**
       * @memberOf module:bs_406
       * @this thn.widgets.price
       * @see {@link Price#get_promocode}
       *
       * @param {object} ctx - The context object.
       */
    engine.getPromocode = function getPromocode(ctx) {
        const promocode = document.querySelector('#promocode')?.value;
        if (promocode) {
            ctx.promocode = promocode;
        }
        return ctx.promocode;
    };
    return engine;
}

export { factory };
